import { render, staticRenderFns } from "./PortalView.vue?vue&type=template&id=32fa563a&scoped=true"
import script from "./PortalView.vue?vue&type=script&lang=js"
export * from "./PortalView.vue?vue&type=script&lang=js"
import style0 from "./PortalView.vue?vue&type=style&index=0&id=32fa563a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32fa563a",
  null
  
)

export default component.exports